export const STEP = 'urn:bafor:step:';
export const STEP_PERSON = 'urn:bafor:step:person:kundennummer:';
export const STEP_BETRIEB = 'urn:bafor:step:betrieb:kundennummer:';
export const PMV = 'urn:bafor:pmventerprise:';
export const PMV_PARTNER = 'urn:bafor:pmventerprise:partner:partnerid:';
export const KIWI = 'urn:bafor:kiwi:';
export const KIWI_KINDERGELDFALL = 'urn:bafor:kiwi:kindergeldfall:kindergeldnummer:';
